import React, { useEffect, useState } from 'react'
import FortuneBasketCard from '../components/UI/FortuneBasketCard'
import { fetchProducts } from '../api/productApi'

const Shop = () => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    async function loadProducts() {
      setLoading(true)
      setError('')
      try {
        const data = await fetchProducts()
        if (!cancelled) {
          setProducts(data)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load products')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadProducts()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <>
      <section className="space-top">
        <div className="container">
          <div className="about-title">
            <h2 className="text-lora font-semibold ">Your Fortune Basket</h2>
            <p>
              Welcome to the Astro Store — your one-stop destination for tools,
              remedies, and sacred products that align with your cosmic journey.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          {loading && <p className="text-center py-5">Loading products...</p>}
          {error && !loading && (
            <p className="text-center py-5 text-danger">{error}</p>
          )}
          {!loading && !error && products.length === 0 && (
            <p className="text-center py-5">No products available right now.</p>
          )}
          {!loading && !error && products.length > 0 && (
            <div className="row shop-product-grid g-4">
              {products.map((item) => (
                <div className="col-lg-3 col-md-6 col-12" key={item.product_id}>
                  <FortuneBasketCard item={item} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  )
}

export default Shop
